import { useState } from "react";

export interface ResponseForm {
  id: string;
  title: string;
  subject: string;
  message: string;
}

export const useDeleteModal = () => {
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showTeamDeleteModel, setShowTeamDeleteModel] = useState<boolean>(false);

  const [deletedResponseName, setDeletedResponseName] = useState<string>(""
  );
  const [showDeleteBanner, setShowDeleteBanner] = useState<boolean>(false);
  const [responseForms, setResponseForms] = useState<ResponseForm[]>([
    { id: "1", title: "", subject: "", message: "" },
  ]);

  return {
    showDeleteModal,
    showTeamDeleteModel,
    setShowDeleteModal,
    setShowTeamDeleteModel,
    deletedResponseName,
    setDeletedResponseName,
    showDeleteBanner,
    setShowDeleteBanner,
    responseForms,
    setResponseForms,
  };
};

export default useDeleteModal;
